module.exports = __webpack_public_path__ + "img/criaai.80023d4f.svg";